import { ReactElement } from 'react';
import { Box } from '@mui/material';

import { useStyles } from './useStyles';

interface IProgressLineProps {
  percent?: number;
}

export function ProgressLine({
  percent = 0,
}: IProgressLineProps): ReactElement {
  const { classes, cx } = useStyles();

  if (percent === 0) {
    return <Box className={classes.line} component="span" />;
  }

  return (
    <Box
      className={cx(classes.line, classes.lineActive)}
      component="span"
      sx={{ width: `${percent}%` }}
    />
  );
}
